import { SelectItem } from "primeng/api";

/**
 * Creates SelectItem type from enum
 * @param enumObj enum object
 * @returns Array of selectItem to be used on select dropdown
 */
export function enumToSelectItem(enumObj: any): SelectItem[] {
    return Object.keys(enumObj).map(key => ({
        label: key, // or any other transformation for the display label
        value: enumObj[key]
    }));
}

/**
 * Identifies the enum correspondent value given a string
 * @param enumObj enum
 * @param value string value
 * @returns the enum value
 */
export function getEnumValueFromString<T extends string | number>(enumObj: any, value: T): T | undefined {
    const enumKey = Object.keys(enumObj).find(
        (key) => enumObj[key as keyof typeof enumObj] === value
    );
    // eslint-disable-next-line unicorn/no-negated-condition
    return enumKey !== undefined ? enumObj[enumKey as keyof typeof enumObj] : undefined;
}